if ( $(".slider-sliderSingle").length > 0 ) {

	var sliderSingle = tns({
		"container": ".slider-sliderSingle",
		"controlsContainer": ".slider-sliderSingle-controls",
		"preventScrollOnTouch": "force",
		"controlsPosition": "bottom",
		"controls": false,
		"navPosition": "bottom",
		"mouseDrag": true,
		"speed": 400,
		"fixedWidth": 320,
		"gutter": 0,
		"center": true,
		"responsive": {
			"768": {
				"fixedWidth": 510
			},
			"992": {
				"controls": true,
				"fixedWidth": 582
			},
			"1280": {
				"fixedWidth": 582
			},
			"1366": {
				"fixedWidth": 582
			},
			"1600": {
				"fixedWidth": 582
			}
		}
	});

}

if ( $(".slider-sliderTestimLeft").length > 0 ) {

	var sliderTestimLeft = tns({
		"container": ".slider-sliderTestimLeft",
		"controlsContainer": ".slider-sliderTestimLeft-controls",
		"preventScrollOnTouch": "force",
		"controlsPosition": "bottom",
		"controls": false,
		"navPosition": "bottom",
		"mouseDrag": true,
		"speed": 400,
		"fixedWidth": 344,
		"center": true,
		"responsive": {
			"768": {
				"fixedWidth": 532
			},
			"992": {
				"controls": true,
				"fixedWidth":644
			},
			"1280": {
				"fixedWidth": 816
			},
			"1366": {
				"fixedWidth": 864
			},
			"1600": {
				"fixedWidth": 928
			}
		}
	});

}

// set is-active class to item which should be active based on URL
$(document).ready(function(){
	var currentURL = window.location.pathname;
	$('.nav').find('a').each(function(){
		if ($(this).attr("href") == currentURL) {
			$('.nav a').removeClass("active");
			$(this).addClass("active");
	    }
	})
})
